import { useQuery } from "@tanstack/react-query";
import { api } from "./api.js";

export interface ProfileAvatarData {
  image: string | null;
}
export const profileAvatarKey = (userId?: string) => ["own-profile-avatar", userId];

export function useProfileAvatar(userId?: string) {
  return useQuery({
    queryKey: profileAvatarKey(userId),
    queryFn: ({ signal }) => api.get<ProfileAvatarData>("/auth/profile/avatar", signal),
    enabled: Boolean(userId),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
